import classNames from 'classnames/bind';

import { Heading } from '@americastestkitchen/mise';
import styles from './DetailPageSectionHeader.module.scss';

const cx = classNames.bind(styles);

const sectionHeaderCopy = {
  asides: 'Test Kitchen Techniques',
  equipment: 'Key Equipment',
  headnote: 'Before You Begin',
  ingredients: 'Gather Your Ingredients',
  instructions: 'Instructions',
  rating: 'My Rating',
  recommendation: 'Recommended Reading',
  relateds: 'Recipe Pairings',
  nutrition: 'Nutritional Information',
  why: 'Why This Recipe Works',
};

type RecipeSection = keyof typeof sectionHeaderCopy;

type DetailPageSectionHeaderProps = {
  className?: string;
  section?: RecipeSection;
  overrideText?: string | number;
};

const DetailPageSectionHeader: React.FC<DetailPageSectionHeaderProps> = ({
  className,
  section,
  overrideText,
}) => {
  const classNames = cx(
    styles.sectionHeader,
    {
      asides: section === 'asides',
    },
    className,
  );
  let sectionHeader: string | number = '';
  if (overrideText) {
    sectionHeader = overrideText;
  } else if (section) {
    sectionHeader = sectionHeaderCopy[section];
  }
  return (
    <Heading className={classNames} as="h2">
      {sectionHeader}
    </Heading>
  );
};

export default DetailPageSectionHeader;
